import { Field, Form, Formik } from 'formik';
import { NavLink, useNavigate } from 'react-router-dom';
import useUserOrg from '../../Authentication/components/hooks/useUserOrg';
import { useDeviceInvite } from './hooks/useDeviceInvite';
import { useDeviceGroupList } from './hooks/useDeviceGroupList';

interface CreateDeviceInviteFormValues {
    name: string;
    groupId: number;
}

export default function CreateDeviceInvite() {
    const { orgId } = useUserOrg();
    const navigate = useNavigate();
    const { createDeviceInvite, error } = useDeviceInvite(orgId);
    const { deviceGroups, isLoading } = useDeviceGroupList(orgId);
    const initialValues: CreateDeviceInviteFormValues = {
        name: '',
        groupId: 0,
    };

    if (isLoading) {
        return <div>loading...</div>;
    }

    return (
        <div>
            <div className="Row-container">
                <h1>create device invite</h1>
            </div>
            <p>
                creates an invite for a device to be assigned to a device group
            </p>
            {error && <div>{error}</div>}
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, actions) => {
                    const wasSuccessful = await createDeviceInvite(values);
                    actions.setSubmitting(false);

                    if (wasSuccessful) {
                        navigate(`/device-groups`);
                    }
                }}
            >
                <Form
                    className="Form"
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                >
                    <div>
                        <label htmlFor="name">device name</label>
                        <Field id="name" name="name" placeholder="" />
                    </div>
                    <br />
                    <div>
                        <label htmlFor="groupId">device group</label>
                        <Field as="select" id="groupId" name="groupId">
                            <option value={0}>Select a device group</option>
                            {deviceGroups.map((group) => (
                                <option key={group.id} value={group.id}>
                                    {group.name}
                                </option>
                            ))}
                        </Field>
                    </div>
                    <br />
                    <div className="Layout-row">
                        <button type="submit" className="Primary-button">
                            create invite
                        </button>
                        <NavLink
                            to={`/device-groups`}
                            className="Secondary-button"
                        >
                            <span>cancel</span>
                        </NavLink>
                    </div>
                </Form>
            </Formik>
        </div>
    );
}
